<div class="alert__wrapper">
	<div class="alert__header">
		{{'settings_alert_zoom' | translate:systemLanguage}}
	</div>
	<div class="alert__buttons">
		<button mat-flat-button (click)="acceptAndClose()">{{'restart' | translate:systemLanguage}}</button>
		<button mat-flat-button (click)="close()">{{'cancel' | translate:systemLanguage}}</button>
	</div>
</div>
